const currency = "SGD";
const serviceTax = 0.07;

// from wess-legacy
function round(num, length) {
  return Number(Math.round(num+'e'+length)+'e-'+length).toFixed(length);
}

// from wess-legacy
function getFormattedNumber(number, format = '.00', check_percent = false) {
  var epsilon = 0.00001;
  var num_dp = format.length - 1;

  if (num_dp > 4) {
      epsilon = 0.0000001;
  }

  var num = parseFloat(number);
  if (Math.abs(num - 0) < epsilon) { //consider equal
      num = 0;
  }

  // toFixed causing 0.035, 0.055, 0.075 cant rounded properly,
  // using customized rounding function
  var formatted = round(parseFloat(num), num_dp);
  if (check_percent === true) {
    formatted += "%";
  }
  return formatted;
}

const formatPrice = (price) => {
  let formatPrice = parseFloat(price).toFixed(2).toString();
  if (isNaN(formatPrice)) {
    return "0.00";
  }
  return formatPrice;
};

const formatPriceSGD = (price) => {
  if (parseFloat(price) < 0) {
    return `-${currency} ${(parseFloat(price) * -1).toFixed(2).toString()}`;
  }
  return `${currency} ${parseFloat(price).toFixed(2).toString()}`;
};

const calculateTax = (price) =>
  (parseFloat(price) * serviceTax).toFixed(2).toString();

const getGrandTotal = (price) =>
  (parseFloat(price) + parseFloat(price) * serviceTax).toFixed(2).toString();

export { getFormattedNumber, formatPrice, formatPriceSGD, calculateTax, getGrandTotal };
